import { render, staticRenderFns } from "./desmatamento-mapbiomas.vue?vue&type=template&id=1ba70140&lang=pug"
import script from "./desmatamento-mapbiomas.vue?vue&type=script&lang=js"
export * from "./desmatamento-mapbiomas.vue?vue&type=script&lang=js"
import style0 from "./desmatamento-mapbiomas.vue?vue&type=style&index=0&id=1ba70140&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports